import React from "react";
import { Outlet } from "react-router-dom";

const UserLayout = () => {
  return (
    <div className="user-layout">
      <div className="user-content">
        <Outlet />
      </div>
    </div>
  );
};

export default UserLayout;
